import React from 'react';
import { Box } from '@mui/material';
import Tooltip, { TooltipProps } from '../../mui-builder/Tooltip/Tooltip';
import { FieldProps } from '../types';
import DateField from './DateField';

export type DateFieldWithPrefixProps = FieldProps & { dateFormat?: string; tooltipProps?: TooltipProps };

const DateFieldWithPrefix = ({ tooltipProps, ...props }: DateFieldWithPrefixProps) => {
  return (
    <Box display="flex" alignItems="center" gap="5px">
      {tooltipProps && <Tooltip {...tooltipProps} />}
      <DateField {...props} />
    </Box>
  );
};

export default DateFieldWithPrefix;
